import { render, staticRenderFns } from "./indexc.vue?vue&type=template&id=4b85d653&scoped=true"
import script from "./indexc.vue?vue&type=script&lang=js"
export * from "./indexc.vue?vue&type=script&lang=js"
import style0 from "./indexc.vue?vue&type=style&index=0&id=4b85d653&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b85d653",
  null
  
)

export default component.exports